<template>
  <v-autocomplete test-tag="tag-1"
    filled
    outlined
    v-if="!allow_inexact"  
    :search-input.sync="search"
    :loading="loading"
    hide-no-data
    :items="items"

    @input="e => $emit('input', e)"
    
    :value="value"
    no-filter
    disable-lookup
    return-object
    item-text="value"
    
    v-bind="$attrs"
    v-on="$listeners"

    :class="{ 'changed': is_changed }"
    :rules="rules"
  >
    <template v-slot:prepend v-if="hint">
      <v-tooltip top right>
        <template v-slot:activator="{ on }">
          <v-icon v-on="on">
            mdi-help-circle-outline
          </v-icon>
        </template>
        <span style="white-space: pre-wrap" v-html="hint"></span>
      </v-tooltip>
    </template>
  </v-autocomplete>
  <v-combobox
    dense
    filled
    outlined
    v-else
    :search-input.sync="search"
    :loading="loading"
    hide-no-data
    :items="items"

    @input="e => $emit('input', e)"
    
    :value="value"
    no-filter
    disable-lookup
    return-object
    item-text="value"
    
    v-bind="$attrs"
    v-on="$listeners"

    :class="{ 'changed': is_changed }"
    :rules="rules"
  >
    <template v-slot:prepend v-if="hint">
      <v-tooltip top right>
        <template v-slot:activator="{ on }">
          <v-icon v-on="on">
            mdi-help-circle-outline
          </v-icon>
        </template>
        <span style="white-space: pre-wrap" v-html="hint"></span>
      </v-tooltip>
    </template>
  </v-combobox>
</template>


<script>
export default {
  props: {
    value: [String, Object], 
    hint: String, 
    original_value: [String, Object], 
    allow_inexact: Boolean,
    rules: Array
  },
  data: () => ({
    search: null,
    loading: false,
    items: [],
    debounce: null,
  }),
  watch: {
    search(cond) {
      cond && cond != this.value?.value && this.debounceQuerySelections(cond)
    }
  },
  computed: {
    is_changed(){
      if (this.original_value) {
        return this.original_value.value !== this.value.value || this.original_value.coordinates?.lat !== this.value.coordinates?.lat || this.original_value.coordinates?.lng !== this.value.coordinates?.lng
      } else return false
    }
  },
  methods: {
    async debounceQuerySelections(cond) {
      this.items = []
      this.loading = true
      
      if (this.debounce != null) {
        clearTimeout(this.debounce)
        this.debounce = null
      }

      this.debounce = setTimeout(this.querySelections, 1000, cond)
    },
    async querySelections(cond) {
      try {
        this.items = await this.$store.dispatch('suggestAddress', cond)

      } finally {
        this.loading = false
      }
    }
  },
  mounted(){
    if (this.value?.value) {
      this.items = [
        this.value
      ]
    }
  }

}
</script>

<style scoped>
.changed {
  position: relative;
}

.changed::after {
  content: " ";
  color: white;
  text-align: center;
  vertical-align: center;
  padding: 0;
  width: 10px;
  height: 10px;
  position: absolute;
  left: -5px;
  top: -5px;
  border-radius: 50%;
  background: var(--v-warning-base);
}
</style>
